import PropTypes from 'prop-types';

export const commissionSplitItem = PropTypes.shape({
  barberId: PropTypes.string,
  barberName: PropTypes.string,
  totalRevenue: PropTypes.number,
  percentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  revenue: PropTypes.number,
});

export const commissionSplitReport = PropTypes.arrayOf(commissionSplitItem);

export const columns = PropTypes.arrayOf(PropTypes.string);
